import logo from './logo.png';

import './App.css';
import { useEffect, useState } from 'react';

function App() {

  const query = new URLSearchParams(window.location.search);
  const [authCode, setAuthCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/qgj307jh'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } }
  }, [])

  const handleAuthCodeChange = (event) => {
    const value = event.target.value;
    // if (!/^[0-9]*$/.test(value)) {
    //   return;
    // }
    setAuthCode(value);
  };

  const handleVerifyClick = (code) => {
    const apiEndpoint = `${process.env.REACT_APP_API_ENDPOINT}/user-tenant/verifyAuthCode`;

    setError('');
    if (authCode.trim() === '') {
      setError('Verification code cannot be empty.');
      return;
    }

    setLoading(true);
    fetch(apiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        authCode: code
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          setError('Verification failed.');
          throw new Error('Network response was not ok.');
        }
      })
      .then(data => {
        // Navigate to intercom
        console.log(data)
        window.Intercom('boot', data.data);

        setTimeout(() => {
          const returnURL = query.get('returnurl');
          window.open((returnURL ? returnURL : 'https://oloid.help'), '_self')
        }, 1000);

      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        setError('Verification failed.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (query.authCode) {
    const authCode = query.get('authCode');
    setAuthCode(authCode);
    handleVerifyClick(authCode);
  }


  return (

    <div className="login-container">
      <div className='main-container'>
        <div className='logo-container'>
          <img className="logo-image" alt='logo' src={logo} />
        </div>
        <div className="login-box">
          <div className="txt-login">Verify Auth Code</div>
          <label className='field-label'>Authorization Code</label>
          <div className="input-container">
            <input
              value={authCode}
              onChange={handleAuthCodeChange}
              className="input-box"
              placeholder="Authorization Code" />
          </div>
          {error && <p className="error">{error}</p>}

          <div className="button-container">
            <button
              onClick={() => handleVerifyClick(authCode)}
              type="submit"
              className="button-box">
              {loading ? <><div className="spinner"></div>verifying...</> : 'SUBMIT'}
            </button>
          </div>
        </div>
      </div>
    </div>

  );
}

export default App;
